const clockwise = ['C', 'G', 'D', 'A', 'E', 'B', 'Gb', 'Db', 'Ab', 'Eb', 'Bb', 'F'];
const innerClockwise = ['Am', 'Em', 'Bm', 'FShm', 'CShm', 'GShm', 'Ebm', 'Bbm', 'Fm', 'Cm', 'Gm', 'Dm'];
const heyJoe = ['C', 'G', 'D', 'A', 'E'];
const heyJude = ['F', 'C', 'G', 'D'];
const hotelCalifornia = ['Am', 'E', 'G', 'D', 'F', 'C', 'Dm', 'E'];
const letItBe = ['C', 'G', 'Am', 'F'];
const callMe = ['Dm', 'F', 'G', 'Bb'];
const vivaLaVida = ['C', 'D', 'G', 'Em'];
const sweetCaroline = ['A', 'D', 'A', 'E'];
export const songs = {
    clockwise: {
        sequence: clockwise,
        name: 'Outer Clockwise'
    },
    heyJoe: {
        sequence: heyJoe,
        name: 'Hey Joe'
    },
    heyJude: {
        sequence: heyJude,
        name: 'Hey Jude'
    },
    innerClockwise: {
        sequence: innerClockwise,
        name: 'Inner Clockwise'
    },
    hotelCalifornia: {
        sequence: hotelCalifornia,
        name: 'Hotel California'
    },
    letItBe: {
        sequence: letItBe,
        name: 'Let It Be'
    },
    callMe: {
        sequence: callMe,
        name: 'Call Me'
    },
    vivaLaVida: {
        sequence: vivaLaVida,
        name: 'Viva La Vida'
    },
    sweetCaroline: {
        sequence: sweetCaroline,
        name: 'Sweet Caroline'
    }
};
